"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContentTypes;
(function (ContentTypes) {
    ContentTypes["PLAIN"] = "text/plain";
    ContentTypes["JSON"] = "application/json";
})(ContentTypes || (ContentTypes = {}));
exports.default = ContentTypes;
//# sourceMappingURL=content-types.js.map